import { render } from "./blood_transfusion.vue?vue&type=template&id=355371dc&scoped=true"
import script from "./blood_transfusion.vue?vue&type=script&lang=js"
export * from "./blood_transfusion.vue?vue&type=script&lang=js"

import "./blood_transfusion.vue?vue&type=style&index=0&id=355371dc&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355371dc"]])

export default __exports__